// Shared vocabulary for every approval dashboard (assessments, activities, events, ...).
// Stage keys are the backend's canonical stages; `changes_requested` is the derived display status.
// Standard: Summary/features/approval_workflow_standard.md

export const STAGE_META = {
  draft: { label: "Draft", pill: "bg-slate-100 text-slate-700 border-slate-200", dot: "bg-slate-400" },
  hod_review: { label: "Awaiting HOD", pill: "bg-amber-50 text-amber-800 border-amber-200", dot: "bg-amber-500" },
  admin_review: { label: "Awaiting Admin", pill: "bg-blue-50 text-blue-800 border-blue-200", dot: "bg-blue-500" },
  approved: { label: "Approved · not public", pill: "bg-emerald-50 text-emerald-800 border-emerald-200", dot: "bg-emerald-500" },
  published: { label: "Published", pill: "bg-teal-50 text-teal-800 border-teal-200", dot: "bg-teal-500" },
  changes_requested: { label: "Changes requested", pill: "bg-rose-50 text-rose-800 border-rose-200", dot: "bg-rose-500" },
};

export const metaFor = (displayStatus, stage) => STAGE_META[displayStatus] || STAGE_META[stage] || STAGE_META.draft;

export const FILTERS = [
  { key: "pending", label: "Needs my review" },
  { key: "hod_review", label: "Awaiting HOD" },
  { key: "admin_review", label: "Awaiting Admin" },
  { key: "changes_requested", label: "Changes requested" },
  { key: "approved", label: "Approved" },
  { key: "published", label: "Published" },
  { key: "all", label: "All" },
];

const ROLE_LABEL = { teacher: "Teacher", hod: "HOD", admin: "Admin", system: "System", system_edit: "System" };
export const roleLabel = (role) => ROLE_LABEL[role] || role || "";

export function describeHistoryEntry(e) {
  switch (e.action) {
    case "submit": return "Submitted for HOD review";
    case "recall": return "Recalled by the teacher";
    case "approve": return e.role === "admin" ? "Approved by admin" : "Approved by HOD, sent to admin";
    case "request_changes": return e.from === "admin_review" && e.role === "admin" ? "Admin sent back to HOD" : "Changes requested";
    case "request_changes_teacher": return "Admin sent back to teacher";
    case "hod_override": return "Admin skipped the HOD approval";
    case "publish": return "Published to students";
    case "unpublish": return "Unpublished";
    case "material_edit": return "Edited after approval; re-approval required and no longer public";
    case "backfill": return "Existing item brought under the approval workflow";
    default: return e.action || "Updated";
  }
}

export function formatWhen(v) {
  if (!v) return "";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleString(undefined, { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function timeAgo(v) {
  if (!v) return "";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return "";
  const mins = Math.round((Date.now() - d.getTime()) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  return hrs < 48 ? `${hrs}h ago` : `${Math.round(hrs / 24)}d ago`;
}
